var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortmatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9399 0.896484H26.9099H35.8799V10.0963H26.9099H17.9399H8.96996V19.2961V19.886V28.4424V28.496V37.6422H0V28.496V28.4424V19.886V19.2961V10.0963V0.896484H8.96996H17.9399ZM26.9105 28.4452H17.9928V19.299H35.8752V28.767C35.8752 31.1207 34.9639 33.378 33.3417 35.0428C31.7195 36.7076 29.5191 37.6436 27.2242 37.6451H26.9105V28.4452Z",
    fill: "#6851FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortmatic);
export default __webpack_public_path__ + "static/media/fortmatic.f75166296e36167fcf54274d2cc9ac48.svg";
export { ForwardRef as ReactComponent };